
export const APP_VERSION = '3.0.2'; // add shoes
export const BUILD_DATE = '04-11-2026';
